function displayDistance(distanceKm: number) {
  if (distanceKm >= 1) {
    return `${distanceKm.toFixed(2)} km`;
  } else {
    let distanceMeters = distanceKm * 1000;
    return `${Math.round(distanceMeters)} m`;
  }
}

const helpers = {
  displayDistance,
};

export default helpers;
